/* The Rugs :: journal hub (/pages/blogs). Story count, shuffle, saved hearts, weekly poll.
   Series tiles are plain links to each blog, so there is no in-page category filter. */
(function () {
  var root = document.querySelector('[data-hub]');
  if (!root) return;

  var KEY = 'therugs:saved-guides';
  var PKEY = 'therugs:hub-poll';
  var grid = root.querySelector('[data-hub-grid]');
  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-cat]')) : [];
  var countEl = root.querySelector('[data-hub-count]');
  var savedEl = root.querySelector('[data-hub-saved]');

  cards.sort(function (a, b) {
    return parseInt(b.getAttribute('data-ts') || '0', 10) - parseInt(a.getAttribute('data-ts') || '0', 10);
  });
  cards.forEach(function (c) { grid.appendChild(c); });

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function paintSaved() {
    var list = read();
    if (savedEl) savedEl.textContent = String(list.length);
    Array.prototype.forEach.call(root.querySelectorAll('[data-save]'), function (b) {
      var on = list.indexOf(b.getAttribute('data-save')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = on ? '\u2665' : '\u2661';
    });
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-save]'), function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-save');
      var list = read(); var at = list.indexOf(h);
      if (at > -1) list.splice(at, 1); else list.push(h);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) {}
      paintSaved();
    });
  });
  paintSaved();

  if (countEl) countEl.textContent = '\u00b7 ' + cards.length + (cards.length === 1 ? ' story' : ' stories');

  var shuffleBtn = root.querySelector('[data-hub-shuffle]');
  if (shuffleBtn) {
    shuffleBtn.addEventListener('click', function () {
      cards.slice().sort(function () { return Math.random() - 0.5; }).forEach(function (c) { grid.appendChild(c); });
    });
  }

  var poll = root.querySelector('[data-hub-poll]');
  if (poll) {
    var base = { a: parseInt(poll.getAttribute('data-seed-a') || '0', 10) || 0, b: parseInt(poll.getAttribute('data-seed-b') || '0', 10) || 0 };
    var voted = null;
    try { voted = (JSON.parse(localStorage.getItem(PKEY) || 'null') || {}).v || null; } catch (e) {}
    var totalEl = poll.querySelector('[data-poll-total]');
    var hintEl = poll.querySelector('[data-poll-hint]');

    var paintPoll = function () {
      var v = { a: base.a, b: base.b };
      if (voted) v[voted] += 1;
      var tot = v.a + v.b;
      var pa = Math.round(v.a / tot * 100), pb = 100 - pa;
      var pct = { a: pa, b: pb };
      Array.prototype.forEach.call(poll.querySelectorAll('[data-poll-opt]'), function (o) {
        var k = o.getAttribute('data-poll-opt');
        o.querySelector('[data-poll-bar]').style.width = voted ? pct[k] + '%' : '0%';
        o.querySelector('[data-poll-pct]').textContent = voted ? pct[k] + '%' : '';
        o.style.borderColor = voted === k ? '#788069' : 'rgba(27,23,18,.12)';
        o.setAttribute('aria-pressed', voted === k ? 'true' : 'false');
        var lab = o.querySelector('[data-poll-label]');
        if (lab) lab.textContent = lab.getAttribute('data-base') + (voted === k ? ' \u00b7 your pick' : '');
      });
      if (totalEl) totalEl.textContent = tot + ' readers have voted';
      if (hintEl) hintEl.textContent = voted ? 'Thanks for voting.' : 'Tap a side to vote';
    };
    Array.prototype.forEach.call(poll.querySelectorAll('[data-poll-opt]'), function (o) {
      o.addEventListener('click', function () {
        if (voted) return;
        voted = o.getAttribute('data-poll-opt');
        try { localStorage.setItem(PKEY, JSON.stringify({ v: voted })); } catch (e) {}
        paintPoll();
      });
    });
    paintPoll();
  }
})();
